import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import {CardComponent} from './card/card.component';
import {PaginationModule} from 'ngx-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AgmCoreModule} from '@agm/core';

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      PaginationModule.forRoot()
  ],
  declarations: [
      CardRefreshDirective,
      CardToggleDirective,
      CardComponent,
  ],
  exports: [
      CardRefreshDirective,
      CardToggleDirective,
      CardComponent,
      PaginationModule,
      FormsModule,
      ReactiveFormsModule,
      AgmCoreModule,
  ],
  providers: [
  ]
})
export class SharedModule { }
